import {ProizvodnjaModel} from '../../models/ProizvodnjaModel'

const numericValue = (value: unknown) => {
  const parsed = Number.parseFloat(String(value ?? 0))
  return Number.isFinite(parsed) ? parsed : 0
}

export const getOtpremaArea = (row: Pick<ProizvodnjaModel, 'panel_pakovanja2'>) =>
  Array.isArray(row.panel_pakovanja2)
    ? row.panel_pakovanja2.reduce(
        (sum, panel) =>
          sum +
          (numericValue(panel.duzina) / 1000) *
            (numericValue(panel.sirinaPaketa) / 1000) *
            numericValue(panel.brPanela),
        0
      )
    : 0

export const getOtpremaCijena = (
  row: Pick<ProizvodnjaModel, 'panel_pakovanja2' | 'cijenaProzivoda'>
) => getOtpremaArea(row) * numericValue(row.cijenaProzivoda)
